import { useCallback } from 'react';

import * as server from '../server';
import { useAppSelector } from 'js/store/hooks';
import { prop } from 'ramda';

export const useCheckInDotComListenerRequest = () => {
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async ({ requestContent, getParameters }) => {
        const { data: { actions } } = await server.checkInDotComListener({
            requestContent,
            getParameters,
            casinoName
        });

        return { actions };
    }, [
        casinoName
    ]);
};
